<template>
  <section id="Create">
    <div class="createTitle">
      <p>CREATE</p>
      <span>ACCOUNT | COMPANY | E-VOTING | AUTHENTICATION</span>
    </div>
    <div class="cardContainer">
      <v-card height="250px" class="elevation-5 createCard c-con-grad" 
        v-if="this['user/user'].resources['user'] && this['user/user'].resources['user'].indexOf('create') > -1"
      >
        <p class="c-con-txt">USER</p>
        <div class="c-con-btn">
          <v-btn round small to="/user-accounts/create">CREATE</v-btn>
        </div>
      </v-card>
      <v-card height="250px" class="elevation-5 createCard c-con-grad-lead"
        v-if="this['user/user'].resources['company'] && this['user/user'].resources['company'].indexOf('create') > -1"
      >
        <p class="c-con-txt">COMPANY</p>
        <div class="c-con-btn">
          <v-btn round small to="/company/create">CREATE</v-btn>
        </div>
      </v-card>
      <v-card height="250px" class="elevation-5 createCard c-con-grad-account"
        v-if="this['user/user'].resources['evoting-entity'] && this['user/user'].resources['evoting-entity'].indexOf('create') > -1"
      >
        <p class="c-con-txt">EVOTING ENTITY</p>
        <div class="c-con-btn">
          <v-btn round small to="/evoting/entity/create">CREATE</v-btn>
        </div>
      </v-card>
      <v-card height="250px" class="elevation-5 createCard c-con-grad-deal"
        v-if="this['user/user'].resources['evoting-event'] && this['user/user'].resources['evoting-event'].indexOf('create') > -1"
      >
        <p class="c-con-txt">EVOTING EVENT</p>
        <div class="c-con-btn">
          <v-btn round small to="/evoting/event/create">CREATE</v-btn>
        </div>
      </v-card>
      <v-card height="250px" class="elevation-5 createCard c-con-grad-account"
        v-if="this['user/user'].resources['resource'] && this['user/user'].resources['resource'].indexOf('create') > -1"
      >
        <p class="c-con-txt">AUTH RESOURCES</p>
        <div class="c-con-btn">
          <v-btn round small to="/authentication/create">CREATE</v-btn>
        </div>
      </v-card>
      <v-card height="250px" class="elevation-5 createCard c-con-grad"
        v-if="this['user/user'].resources['action'] && this['user/user'].resources['action'].indexOf('create') > -1"
      >
        <p class="c-con-txt">AUTH ACTIONS</p>
        <div class="c-con-btn">
          <v-btn round small to="/authentication/create">CREATE</v-btn>
        </div>
      </v-card>
      <v-card height="250px" class="elevation-5 createCard c-con-grad-lead"
        v-if="this['user/user'].resources['role'] && this['user/user'].resources['role'].indexOf('create') > -1"
      >
        <p class="c-con-txt">AUTH ROLE</p>
        <div class="c-con-btn">
          <v-btn round small to="/authentication/create">CREATE</v-btn>
        </div>
      </v-card>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["user/user"])
  }
};
</script>


<style lang="stylus" scoped>
@import '../assets/stylus/Create.styl';
</style>
